/**
 * Category Filter Component
 * Displays filter tabs for proposal categories
 */
export function CategoryFilter({ categories, selectedCategory, onCategoryChange }) {
  return (
    <div className="t24-category-filters">
      {/* All Categories Button */}
      <button
        className={`t24-category-filter-btn ${selectedCategory === '' ? 'active' : ''}`}
        onClick={() => onCategoryChange('')}
      >
        All
      </button>

      {/* Individual Category Buttons */}
      {Object.entries(categories).map(([key, label]) => (
        <button
          key={key}
          className={`t24-category-filter-btn ${selectedCategory === key ? 'active' : ''}`}
          onClick={() => onCategoryChange(key)}
        >
          {label}
        </button>
      ))}
    </div>
  );
}
